import "es6-promise/auto";

import {
    setContent
} from "viewport-extra";

var ua = navigator.userAgent;
var isSmartPhone =
    ua.indexOf("iPhone") > -1 || (ua.indexOf("Android") > -1 && ua.indexOf("Mobile") > -1);

var isTablet = !isSmartPhone &&
    (ua.indexOf("iPad") > -1 ||
        (ua.indexOf("Macintosh") > -1 && "ontouchend" in document) ||
        ua.indexOf("Android") > -1);

window.addEventListener("DOMContentLoaded", (e) => {
    if (isSmartPhone) {
        setContent({
            minWidth: 375,
        });
    } else if (isTablet) {
        setContent({
            minWidth: 1160,
        });
    }
});

import $ from "jquery";
//import 'slick-carousel';
import "./slick.js";
var mvslider = $(".mv-slide");

if (mvslider) {
    mvslider.slick({
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: true,
        centerPadding: "9.956vw",
        cssEase: "cubic-bezier(0.45, 0, 0.55, 1)",
        //slidesToShow: 1,
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding: "0",
                },
      },
    ],
        //centerMode: true,
        //	variableWidth: true
    });
}

var reasonslider = $(".reason-slider");

if (reasonslider) {
    reasonslider.slick({
        //	autoplay: true,
        //	autoplaySpeed: 3000,
        //centerMode: true,
        //centerPadding: '9.297vw',
        cssEase: "cubic-bezier(0.45, 0, 0.55, 1)",
        //slidesToShow: 1,
        dots: false,
        infinite: true,
        swipe: true,
        swipeToSlide: true,
        speed: 500,
        slidesToShow: 3,
        //centerMode: true,
        variableWidth: true,
//        prevArrow: '<button class="slick-prev slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.063" height="20.587" viewBox="0 0 11.063 20.587"><path d="M694.125,836.969l-10.358-10.231,10.356-10.356.707.707-9.644,9.644,9.642,9.524Z" transform="translate(-683.767 -816.382)" fill="#897367"/></svg></button>',
//        nextArrow: '<button class="slick-next slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.063" height="20.587" viewBox="0 0 11.063 20.587"><path d="M684.827,836.969l-.7-.711,9.642-9.524-9.644-9.644.707-.707,10.356,10.356Z" transform="translate(-684.122 -816.382)" fill="#897367"/></svg></button>',
        prevArrow: '<button class="slick-prev slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.84" height="7.368" viewBox="0 0 11.84 7.368"><path d="M685.179,827.868l-1.405-1.423,4.527-4.471-4.531-4.531,1.414-1.414,5.954,5.954Z" transform="translate(-816.029 691.137) rotate(-90)" /></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.84" height="7.368" viewBox="0 0 11.84 7.368"><path d="M685.179,827.868l-1.405-1.423,4.527-4.471-4.531-4.531,1.414-1.414,5.954,5.954Z" transform="translate(-816.029 691.137) rotate(-90)" /></svg></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                },
      },
    ],
    });
}


var arrivalsslider = $(".arrivals-slider");

if (arrivalsslider) {
    arrivalsslider.slick({
        //	autoplay: true,
        //	autoplaySpeed: 3000,
        //centerMode: true,
        //centerPadding: '9.297vw',
        cssEase: "cubic-bezier(0.45, 0, 0.55, 1)",
        //slidesToShow: 1,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        swipe: true,
        swipeToSlide: true,
        //centerMode: true,
        variableWidth: true,
//        prevArrow: '<button class="slick-prev slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.063" height="20.587" viewBox="0 0 11.063 20.587"><path d="M694.125,836.969l-10.358-10.231,10.356-10.356.707.707-9.644,9.644,9.642,9.524Z" transform="translate(-683.767 -816.382)" fill="#897367"/></svg></button>',
//        nextArrow: '<button class="slick-next slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.063" height="20.587" viewBox="0 0 11.063 20.587"><path d="M684.827,836.969l-.7-.711,9.642-9.524-9.644-9.644.707-.707,10.356,10.356Z" transform="translate(-684.122 -816.382)" fill="#897367"/></svg></button>',
        prevArrow: '<button class="slick-prev slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.84" height="7.368" viewBox="0 0 11.84 7.368"><path d="M685.179,827.868l-1.405-1.423,4.527-4.471-4.531-4.531,1.414-1.414,5.954,5.954Z" transform="translate(-816.029 691.137) rotate(-90)" /></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.84" height="7.368" viewBox="0 0 11.84 7.368"><path d="M685.179,827.868l-1.405-1.423,4.527-4.471-4.531-4.531,1.414-1.414,5.954,5.954Z" transform="translate(-816.029 691.137) rotate(-90)" /></svg></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                },
      },
    ],
    });
}

var repairslider = $(".repair-slider");

if (repairslider) {
    repairslider.slick({
        //	autoplay: true,
        //	autoplaySpeed: 3000,
        //centerMode: true,
        //centerPadding: '9.297vw',
        cssEase: "cubic-bezier(0.45, 0, 0.55, 1)",
        //slidesToShow: 1,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        swipe: true,
        swipeToSlide: true,
        //centerMode: true,
        variableWidth: true,
//        prevArrow: '<button class="slick-prev slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.063" height="20.587" viewBox="0 0 11.063 20.587"><path d="M694.125,836.969l-10.358-10.231,10.356-10.356.707.707-9.644,9.644,9.642,9.524Z" transform="translate(-683.767 -816.382)" fill="#897367"/></svg></button>',
//        nextArrow: '<button class="slick-next slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.063" height="20.587" viewBox="0 0 11.063 20.587"><path d="M684.827,836.969l-.7-.711,9.642-9.524-9.644-9.644.707-.707,10.356,10.356Z" transform="translate(-684.122 -816.382)" fill="#897367"/></svg></button>',
        prevArrow: '<button class="slick-prev slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.84" height="7.368" viewBox="0 0 11.84 7.368"><path d="M685.179,827.868l-1.405-1.423,4.527-4.471-4.531-4.531,1.414-1.414,5.954,5.954Z" transform="translate(-816.029 691.137) rotate(-90)" /></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.84" height="7.368" viewBox="0 0 11.84 7.368"><path d="M685.179,827.868l-1.405-1.423,4.527-4.471-4.531-4.531,1.414-1.414,5.954,5.954Z" transform="translate(-816.029 691.137) rotate(-90)" /></svg></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                },
      },
    ],
    });
}

///* slick thumbnail settings */
jQuery(document).ready(function ($) {
    if (window.matchMedia("(max-width:767px)").matches) {
        var main = $(".fs-c-productCarouselMainImage");
        var thumb = $(".fs-c-productCarouselMainImage__thumbnail");

        if (thumb.length > 5) {
            main.append(
                '<div class="thumb-arrow" data-thumb="0"><button type="button" class="thumb-prev" disabled>button prev</button><button type="button" class="thumb-next">button next</button></div>'
            );
        }

        var thumb_arrow = $(".thumb-arrow");
        var thumb_list = $(".fs-c-productCarouselMainImage__thumbnailList");

        $(document).on("click", ".fs-c-productCarouselMainImage__thumbnail", function () {
            var index = thumb.index(this);
            var target_x = (thumb.outerWidth() + 5) * index;

            thumb_list.animate({
                scrollLeft: target_x,
            });

            if (thumb.length <= index + 5) {
                thumb_arrow.attr("data-thumb", thumb.length - 5);
                $(".thumb-prev").prop("disabled", false);
                $(".thumb-next").prop("disabled", true);
            } else if (index == 0) {
                $(".thumb-prev").prop("disabled", true);
                $(".thumb-next").prop("disabled", false);
                thumb_arrow.attr("data-thumb", index);
            } else {
                $(".thumb-prev").prop("disabled", false);
                $(".thumb-next").prop("disabled", false);
                thumb_arrow.attr("data-thumb", index);
            }
        });

        $(document).on("click", ".thumb-prev", function () {
            var index = Number(thumb_arrow.attr("data-thumb"));
            var target_x = (thumb.outerWidth() + 5) * (index - 1);

            thumb_list.animate({
                scrollLeft: target_x,
            });

            thumb_arrow.attr("data-thumb", index - 1);

            if (index - 1 <= 0) {
                $(".thumb-prev").prop("disabled", true);
            }

            if (thumb.length >= index - 1 + 5) {
                $(".thumb-next").prop("disabled", false);
            }
        });

        $(document).on("click", ".thumb-next", function () {
            var index = Number(thumb_arrow.attr("data-thumb"));
            var target_x = (thumb.outerWidth() + 5) * (index + 1);

            thumb_list.animate({
                scrollLeft: target_x,
            });
            thumb_arrow.attr("data-thumb", index + 1);

            if (index + 1 > 0) {
                $(".thumb-prev").prop("disabled", false);
            }

            if (thumb.length <= index + 1 + 5) {
                $(".thumb-next").prop("disabled", true);
            }
        });
    }
});

/* slick thumbnail settings */
jQuery(document).ready(function ($) {
    if (window.matchMedia("(min-width:768px)").matches) {
        var main = $(".fs-c-productCarouselMainImage");
        var thumb = $(".fs-c-productCarouselMainImage__thumbnail");

        if (thumb.length > 5) {
            main.append(
                '<div class="thumb-arrow" data-thumb="0"><button type="button" class="thumb-prev" disabled>button prev</button><button type="button" class="thumb-next">button next</button></div>'
            );
        }

        var thumb_arrow = $(".thumb-arrow");
        var thumb_list = $(".fs-c-productCarouselMainImage__thumbnailList");

        $(document).on("click", ".fs-c-productCarouselMainImage__thumbnail", function () {
            var index = thumb.index(this);
            var target_x = (thumb.outerWidth() + 5) * index;

            thumb_list.animate({
                scrollLeft: target_x,
            });

            if (thumb.length <= index + 5) {
                thumb_arrow.attr("data-thumb", thumb.length - 5);
                $(".thumb-prev").prop("disabled", false);
                $(".thumb-next").prop("disabled", true);
            } else if (index == 0) {
                $(".thumb-prev").prop("disabled", true);
                $(".thumb-next").prop("disabled", false);
                thumb_arrow.attr("data-thumb", index);
            } else {
                $(".thumb-prev").prop("disabled", false);
                $(".thumb-next").prop("disabled", false);
                thumb_arrow.attr("data-thumb", index);
            }
        });

        $(document).on("click", ".thumb-prev", function () {
            var index = Number(thumb_arrow.attr("data-thumb"));
            var target_x = (thumb.outerWidth() + 5) * (index - 1);

            thumb_list.animate({
                scrollLeft: target_x,
            });

            thumb_arrow.attr("data-thumb", index - 1);

            if (index - 1 <= 0) {
                $(".thumb-prev").prop("disabled", true);
            }

            if (thumb.length >= index - 1 + 5) {
                $(".thumb-next").prop("disabled", false);
            }
        });

        $(document).on("click", ".thumb-next", function () {
            var index = Number(thumb_arrow.attr("data-thumb"));
            var target_x = (thumb.outerWidth() + 5) * (index + 1);

            thumb_list.animate({
                scrollLeft: target_x,
            });
            thumb_arrow.attr("data-thumb", index + 1);

            if (index + 1 > 0) {
                $(".thumb-prev").prop("disabled", false);
            }

            if (thumb.length <= index + 1 + 5) {
                $(".thumb-next").prop("disabled", true);
            }
        });
    }
});

//var relatedslider = $('.related-slider');
//
//if (relatedslider) {
//    relatedslider.slick({
//        //	autoplay: true,
//        //	autoplaySpeed: 3000,
//        //centerMode: true,
//        //centerPadding: '9.297vw',
//        cssEase: 'cubic-bezier(0.45, 0, 0.55, 1)',
//        //slidesToShow: 1,
//        dots: false,
//        infinite: true,
//        speed: 500,
//        slidesToShow: 4,
//        swipe: true,
//        swipeToSlide: true,
//        //centerMode: true,
//        variableWidth: true,
//        prevArrow: '<button class="slick-prev slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.063" height="20.587" viewBox="0 0 11.063 20.587"><path d="M694.125,836.969l-10.358-10.231,10.356-10.356.707.707-9.644,9.644,9.642,9.524Z" transform="translate(-683.767 -816.382)" fill="#897367"/></svg></button>',
//        nextArrow: '<button class="slick-next slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.063" height="20.587" viewBox="0 0 11.063 20.587"><path d="M684.827,836.969l-.7-.711,9.642-9.524-9.644-9.644.707-.707,10.356,10.356Z" transform="translate(-684.122 -816.382)" fill="#897367"/></svg></button>',
//        responsive: [{
//
//            breakpoint: 768,
//            settings: {
//                slidesToShow: 1,
//                centerMode: true,
//            }
//
//		}]
//    });
//}

//var recommendslider = $('.recommend-slider');
//
//if (recommendslider) {
//
//    recommendslider.slick({
//        //	autoplay: true,
//        //	autoplaySpeed: 3000,
//        //centerMode: true,
//        //centerPadding: '9.297vw',
//        cssEase: 'cubic-bezier(0.45, 0, 0.55, 1)',
//        //slidesToShow: 1,
//        dots: false,
//        infinite: true,
//        speed: 500,
//        slidesToShow: 4,
//        swipe: true,
//        swipeToSlide: true,
//        //centerMode: true,
//        variableWidth: true,
//        prevArrow: '<button class="slick-prev slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.063" height="20.587" viewBox="0 0 11.063 20.587"><path d="M694.125,836.969l-10.358-10.231,10.356-10.356.707.707-9.644,9.644,9.642,9.524Z" transform="translate(-683.767 -816.382)" fill="#897367"/></svg></button>',
//        nextArrow: '<button class="slick-next slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.063" height="20.587" viewBox="0 0 11.063 20.587"><path d="M684.827,836.969l-.7-.711,9.642-9.524-9.644-9.644.707-.707,10.356,10.356Z" transform="translate(-684.122 -816.382)" fill="#897367"/></svg></button>',
//        responsive: [{
//
//            breakpoint: 768,
//            settings: {
//                slidesToShow: 1,
//                centerMode: true,
//            }
//
//		}]
//    });
//
//}

//var historyslider = $('.history-slider');
//
//if (historyslider) {
//    historyslider.slick({
//        //	autoplay: true,
//        //	autoplaySpeed: 3000,
//        //centerMode: true,
//        //centerPadding: '9.297vw',
//        cssEase: 'cubic-bezier(0.45, 0, 0.55, 1)',
//        //slidesToShow: 1,
//        dots: false,
//        infinite: true,
//        speed: 500,
//        slidesToShow: 5,
//        swipe: true,
//        swipeToSlide: true,
//        //centerMode: true,
//        variableWidth: true,
//        prevArrow: '<button class="slick-prev slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.063" height="20.587" viewBox="0 0 11.063 20.587"><path d="M694.125,836.969l-10.358-10.231,10.356-10.356.707.707-9.644,9.644,9.642,9.524Z" transform="translate(-683.767 -816.382)" fill="#897367"/></svg></button>',
//        nextArrow: '<button class="slick-next slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.063" height="20.587" viewBox="0 0 11.063 20.587"><path d="M684.827,836.969l-.7-.711,9.642-9.524-9.644-9.644.707-.707,10.356,10.356Z" transform="translate(-684.122 -816.382)" fill="#897367"/></svg></button>',
//        responsive: [{
//
//            breakpoint: 768,
//            settings: {
//                slidesToShow: 1,
//                centerMode: true,
//            }
//
//		}]
//    });
//}

import SweetScroll from "sweet-scroll";

const sweetScroll = new SweetScroll({
    duration: 1000,
    header: "#header",
    delay: 100,
    easing: "easeOutQuint",
    offset: -10,
    verticalScroll: true,
});

import {
    gsap
} from "gsap";
import {
    ScrollToPlugin
} from "gsap/ScrollToPlugin";
import {
    ScrollTrigger
} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

// load drawer settings
import "./drawer-settings";

// load animation event

window.addEventListener("DOMContentLoaded", (e) => {
    var load_lists = document.querySelectorAll("load-in");

    if (load_lists) {
        for (let i = 0; i < load_lists.length; i++) {
            load_lists[i].classList.add("active");
        }
    }
});

// scroll anchor event

ScrollTrigger.create({
    start: "top -100",
    end: 99999,
    toggleClass: {
        className: "is-on",
        targets: "#anchor-top",
    },
    //, onToggle: ({ progress, direction, isActive }) => console.log(progress, direction, isActive)
});

// scroll animation event
gsap.utils.toArray(".scroll-in").forEach((el) => {
    gsap.to(el, {
        //	x: 500,
        //	className: "+=on",
        scrollTrigger: {
            trigger: el,
            start: "top center", // アニメーション開始位置
            markers: true, // マーカー表示
        },
        onEnter: () =>
            function () {
                //el.toggle('active');
                console.log("enter");
            },
    });
});

// global mega menu

var mega_menu_navi = document.querySelectorAll("#global-menu .has-menu-child > a");

var menu_duration = 0.4;

var paremt_menu_open;

if (mega_menu_navi) {
    for (let i = 0; i < mega_menu_navi.length; i++) {
        //console.log(mega_menu_navi[i]);
        //	load_lists[i].classList.add('active');

        mega_menu_navi[i].addEventListener("mouseenter", function (e) {
            var parent_menu = e.currentTarget.parentNode;

            //	console.log(parent_menu);

            //	console.log(parent_menu.classList.contains('is-open'));

            if (!parent_menu.classList.contains("is-open")) {
                /*
				var mega_menu_open = document.querySelectorAll('.mega-menu.is-open');
	
				console.log(mega_menu_open);
	
				for (let j = 0; j < mega_menu_open.length; j++) {
					mega_menu_open[j].classList.remove('is-open');
					gsap.fromTo(mega_menu_open[j], {
						opacity: 1,
						display: 'block',
	
					}, {
						opacity: 0,
						duration: menu_duration,
						onComplete: function () {
	
							mega_menu_open[j].style.removeProperty('opacity');
							mega_menu_open[j].style.removeProperty('display');
	
						}
					});
	
	
	
	
				}
				*/

                //console.log(parent_menu)

                var target_menu = e.currentTarget.nextElementSibling;
                target_menu.classList.add("active");
                parent_menu.classList.add("is-open");

                target_menu.style.display = "block";

                //console.log(target_menu.scrollHeight);

                gsap.fromTo(
                    target_menu, {
                        opacity: 0,
                        //	height: 0,
                        //display: 'block',
                    }, {
                        opacity: 1,
                        //	height: target_menu.scrollHeight,
                        duration: menu_duration,
                        onComplete: function () {
                            //	sp_drawer_menu.classList.add('is-open');
                            target_menu.style.removeProperty("opacity");
                            target_menu.style.removeProperty("display");
                            target_menu.style.removeProperty("height");
                            //	siteheader.style.removeProperty('position');
                            //	siteheader.style.removeProperty('transform');
                            //dbody.removeChild(drawer_overlay);
                        },
                    }
                );
            }

            //console.log(e.currentTarget.nextElementSibling);

            parent_menu.addEventListener("mouseleave", function (e) {
                //console.log('leave');

                parent_menu.classList.remove("is-open");

                var mega_menu_active = document.querySelectorAll(".mega-menu.active");

                for (let i = 0; i < mega_menu_active.length; i++) {
                    mega_menu_active[i].classList.remove("active");

                    gsap.fromTo(
                        mega_menu_active[i], {
                            opacity: 1,
                            //		height: target_menu.scrollHeight,
                            display: "block",
                        }, {
                            opacity: 0,
                            //	height: 0,
                            duration: menu_duration,
                            onComplete: function () {
                                //		mega_menu_active.style.removeProperty('height');
                                mega_menu_active[i].style.removeProperty("opacity");
                                mega_menu_active[i].style.removeProperty("display");
                            },
                        }
                    );
                }
                //	console.log(target_menu.scrollHeight);

                //	console.log(mega_menu_active);
            });

            e.preventDefault();
        });
    }
}

// faq accordion event

const accordion_title = document.querySelectorAll(".js-accordion-title");

//console.log(accordion_title);

if (accordion_title.length) {
    for (let i = 0; i < accordion_title.length; i++) {
        accordion_title[i].addEventListener("click", function (e) {
            var current_title = e.currentTarget;

            //	var parent_title = current_title.closest('.js-accordion-wrap');
            var parent_contents = current_title.closest(".js-accordion-wrap");

            var current_contents = parent_contents.querySelector(".js-accordion-content");

            //	console.log(parent_contents);

            //	console.log(parent_title);
            //	console.log(current_contents);

            //var panel_contents = current_title.nextElementSibling;

            //	console.log('click');

            var current_contents_height = current_contents.scrollHeight;

            //	console.log(current_contents_height);

            //console.log(parent_contents);

            if (parent_contents.classList.contains("is-open")) {
                //parent_contents.style.height = current_contents_height + 'px';

                //parent_title.classList.remove('is-open');
                parent_contents.classList.remove("is-open");

                gsap.fromTo(
                    current_contents, {
                        opacity: 1,
                        height: current_contents_height,
                        //display: 'block',
                    }, {
                        opacity: 0,
                        duration: 0.3, // アニメーションは1秒間
                        height: 0,
                        onComplete: function () {
                            //	sub_menu.style.removeProperty('opacity');
                            current_contents.style.removeProperty("opacity");
                            current_contents.style.removeProperty("height");
                        }, // 処理後じ実行する関数を指定
                    }
                );
            } else {
                parent_contents.classList.add("is-open");
                //	parent_contents.classList.add('is-open');
                current_contents.style.height = 0;

                gsap.fromTo(
                    current_contents, {
                        opacity: 0,
                        height: 0,
                        //display: 'block',
                    }, {
                        opacity: 1,
                        duration: 0.3, // アニメーションは1秒間
                        height: current_contents_height,
                        onComplete: function () {
                            current_contents.style.removeProperty("opacity");
                            current_contents.style.removeProperty("height");
                        }, // 処理後じ実行する関数を指定
                    }
                );
            }

            //console.log(current_navi);

            e.preventDefault();
        });
    }
}

var js_accordion2_title_icn = $(".js_accordion2_title_icn");

js_accordion2_title_icn.on("click", function () {
    $(this).parent(".bl_accordion2_title").next().slideToggle(200);
    $(this).toggleClass("is_open", 200);
});

var js_accordion3_trigger = $(".js_accordion3_trigger");

js_accordion3_trigger.on("click", function () {
    $(this).next().slideToggle(200);
    $(this).toggleClass("is_open", 200);
});

var setMailPlaceHolder = $("#fs_input_mailAddress");
var setPassPlaceHolder = $("#fs_input_password");
if (setMailPlaceHolder) {
    setMailPlaceHolder.attr("placeholder", "メールアドレス");
}
if (setPassPlaceHolder) {
    setPassPlaceHolder.attr("placeholder", "パスワード");
}

//商品詳細 サイズガイド
//var checkModal_url = location.pathname.split('/');
//var checkModal_cat = checkModal_url[checkModal_url.length - 2];
//var checkModal_cat_id = 'js_checkModal__' + checkModal_cat;
//var js_checkModal_item = $(".bl_modal_size");
//
//if (checkModal_url.length == 4 && checkModal_url[checkModal_url.length - 3] == 'c' && checkModal_cat && js_checkModal_item) {
//    js_checkModal_item.css({
//        'display': 'none',
//    });
//
//    js_checkModal_item.each(function () {
//        if ($(this).attr('id') == checkModal_cat_id) {
//            $(this).css({
//                'display': 'block',
//            });
//        }
//    });
//    var modal_cats = ['ring','necklace', 'pierce', 'bracelet'];
//    var modal_cats_flag = false;
//    $.each(modal_cats, function (index, value) {
//        if (value == checkModal_cat) {
//            modal_cats_flag = true;
//        }
//    });
//    if (!modal_cats_flag) {
//        $('.contact-modal').css({
//                'display': 'none',
//            });
//    } else{
//    }
//}

//商品グループlv2　検索パーツ非表示
//var checkcat_url = location.pathname.split('/');
//var js_checkCat_list = $(".bl_modal_size");
//var js_checkCat_item = $(".js_checkCat_item");
//
//if (checkcat_url[checkcat_url.length - 4] == 'c' && js_checkCat_list) {
//    var checkcat_cat = checkcat_url[checkcat_url.length - 3];
//    console.log(checkcat_url);
//    console.log(checkcat_cat);
//    console.log(js_checkCat_list);
//    console.log(js_checkCat_item);
//    console.log(checkcat_url[checkcat_url.length - 4]);
//
//    js_checkCat_item.css({
//        'display': 'none',
//    });
//
//    js_checkCat_item.each(function () {
//        if ($(this).attr('id') == checkcat_cat) {
//            $(this).css({
//                'display': 'block',
//            });
//            console.log(checkcat_cat);
//        }
//    });
//} else if (checkcat_url[checkcat_url.length - 3] == 'c' && js_checkCat_list) {
//    var checkcat_cat = checkcat_url[checkcat_url.length - 2];
//
//    js_checkCat_item.css({
//        'display': 'none',
//    });
//
//    js_checkCat_item.each(function () {
//        if ($(this).attr('id') == checkcat_cat) {
//            $(this).css({
//                'display': 'block',
//            });
//            console.log('2' + checkcat_cat);
//        }
//    });
//} else if (checkcat_url[checkcat_url.length - 2] == 'c' && js_checkCat_list) {
//    var checkcat_cat = checkcat_url[checkcat_url.length - 1];
//
//    js_checkCat_item.css({
//        'display': 'none',
//    });
//
//    js_checkCat_item.each(function () {
//        if ($(this).attr('id') == checkcat_cat) {
//            $(this).css({
//                'display': 'block',
//            });
//            console.log('2' + checkcat_cat);
//        }
//    });
//} else if (checkcat_url[3] == 'search' && js_checkCat_list) {
//    var tagValue = [];
//    var url = location.href;
//    var parameters = url.split("?");
//    var searchParams = parameters[1].split("&");
//
//    for (var i = 0; i < searchParams.length; i++) {
//        var searchParam = searchParams[i].split("=");
//        if (searchParam[0] == 'tag') {
//
//           var searchParam2 =  searchParam[1].split("_");
//            tagValue.push(searchParam2[0]);
//        }
//    }
//
//    if (tagValue.length === 1) {
//        console.log(tagValue[0]);
//        js_checkCat_item.each(function () {
//            if ($(this).attr('id') == tagValue[0]) {
//                $(this).css({
//                    'display': 'block',
//                });
//            }
//        });
//    }
//}
//商品グループlv2　検索パーツ非表示
var checkcat_url = location.pathname.split("/");
var js_checkCat_list = $(".js_checkCat_list");
//var js_checkCat_item = $(".js_checkCat_item");
var js_checkCat_lv1 = $(".js_catInput_lv1");
if (checkcat_url[1] == "c" && js_checkCat_list) {
    var checkcat_cat = checkcat_url[2];

    //    js_checkCat_item.css({
    //        'display': 'none',
    //    });
    //
    //    js_checkCat_item.each(function () {
    //        if ($(this).attr('id') == checkcat_cat) {
    //            $(this).css({
    //                'display': 'block',
    //            });
    //        }
    //    });
    js_checkCat_lv1.each(function () {
        var js_checkCat_lv1_id = $(this).attr("id");
        js_checkCat_lv1_id = js_checkCat_lv1_id.split("-");
        js_checkCat_lv1_id = js_checkCat_lv1_id[1];

        if (js_checkCat_lv1_id == checkcat_cat) {
            $(this).prop("checked", true);
            //            console.log(js_checkCat_lv1_id);
        }
    });

    $("input:checked").each(function () {
        var r = $(this).val();

        //        console.log(r);
    });
}

//商品検索結果ページ 検索パーツ非表示
//else if (checkcat_url[2] == 'search' && js_checkCat_list) {
//    var tagValue = [];
//    var url = location.href;
//    var parameters = url.split("?");
//    var searchParams = parameters[1].split("&");
//
//    for (var i = 0; i < searchParams.length; i++) {
//        var searchParam = searchParams[i].split("=");
//        if (searchParam[0] == 'tag') {
//
//            var searchParam2 = searchParam[1].split("_");
//            tagValue.push(searchParam2[0]);
//        }
//    }
//
//    if (tagValue.length === 1) {
//        console.log(tagValue[0]);
//        js_checkCat_item.each(function () {
//            if ($(this).attr('id') == tagValue[0]) {
//                $(this).css({
//                    'display': 'block',
//                });
//            }
//        });
//    }
//}

//sidebar sticky
//var js_sidebar = $('.fs-l-checkout__sideColumn');
//if (js_sidebar) {
//    js_sidebar.parents().css("overflow", "visible");
//}

//let paramList = new Object;
//let prm = location.search.substring(1).split('&');
//let paramSplit;
//for (let i = 0; prm[i]; i++) {
//    paramSplit = prm[i].split('=');
//    paramList[paramSplit[0]] = paramSplit[1];
//    $prm0 = paramSplit[0];
//    $prm1 = paramSplit[1];
//}

//        if (0 === Object.keys(paramList).length) {
//            location.href = "https://survey.mb.softbank.jp/st/cmp/akemashiteomedetou2021/";
//        } else if (!$prm1 || $prm0 !== 'key') {
//            location.href = "https://survey.mb.softbank.jp/st/cmp/akemashiteomedetou2021/";
//        }

//topページ 新着情報
var news = $(".news-lists .no-bullet");
if (news[0]) {
    $.ajax({
            type: "get",
            url: "/news/feed/",
        })
        .done(function (result) {
            if ($(result).find("item")[0]) {
                $(result)
                    .find("item")
                    .each(function (index, element) {
                        var _this = $(element);

                        var link = _this.find("link").text();

                        var titleText = _this.find("title").text();

                        var date = new Date(_this.find("pubDate").text());
                        var dateText = ""
                            .concat(date.getFullYear(), ".")
                            .concat(date.getMonth() + 1, ".")
                            .concat(date.getDate());
                        news.append(
                            '\n            <li>\n              <a href="'
                            .concat(link, '">\n                                  <div class="date">')
                            .concat(dateText, '</div><div class="title">')
                            .concat(titleText, "</div></a>\n            </li>\n          ")
                        );
                    });
            } else {
                news.append('<p class="news-list-notfound"></p>');
            }
        })
        .fail(function () {
            news.append(
                '<p class="news-list-notfound">記事を読み込めませんでした。<br>しばらく時間を置いてから、再度アクセスしてください。</p>'
            );
        });
}


// load sticky fill js
import Stickyfill from "stickyfilljs";
window.addEventListener("DOMContentLoaded", (e) => {
    var elements = document.querySelectorAll(".is-sticky");
    Stickyfill.add(elements);
});

//import "objectFitPolyfill";
//
//window.addEventListener("DOMContentLoaded", (e) => {
//  var element = document.querySelectorAll(".of-image");
//  objectFitPolyfill(element);
//});

import objectFitImages from 'object-fit-images';
if ($(".js_ofiImg")[0]) {
    objectFitImages(".js_ofiImg");
}



//import objectFitImages from 'object-fit-images';
//if ($(".js_ofiImg")[0]) {
//    objectFitImages(".js_ofiImg");
//}


//window.addEventListener("DOMContentLoaded", (e) => {
//  var element = document.querySelectorAll(".of-image");
//  objectFitPolyfill(element);
//});





import "./modal";

import "./lazysizes";

import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";

var item_image_tag = document.querySelectorAll(".fs-c-productCarouselMainImage__image > a");

var openPhotoSwipe = function (selectindex) {
    var pswpElement = document.querySelectorAll(".pswp")[0];

    var item_image_list = document.querySelectorAll(
        ".fs-c-productCarouselMainImage__image > a > img"
    );

    var array_items = [];
    var items = [];
    //console.log(item_image_list);

    for (let i = 0; i < item_image_list.length; i++) {
//        console.log(item_image_list[i].width);

        items.push({
            src: item_image_list[i].src,
            w: item_image_list[i].width,
            h: item_image_list[i].height,
        });
    }

    // define options (if needed)
    var options = {
        // history & focus options are disabled on CodePen
        //	history: false,
        //	focus: false,
        //	showAnimationDuration: 0,
        //	hideAnimationDuration: 0,
        shareEl: false,
        closeOnScroll: false,
        index: selectindex, // start at first slide
    };

    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
};
//openPhotoSwipe();

if (item_image_tag.length) {
    for (let i = 0; i < item_image_tag.length; i++) {
        item_image_tag[i].addEventListener("click", function (e) {
            var current_index = item_image_tag[i]
                .closest(".slick-slide")
                .getAttribute("data-slick-index");

            openPhotoSwipe(current_index);
            //console.log('click');
            /*
                  			var item_image_list = document.querySelectorAll('.fs-c-productCarouselMainImage__image > a > img');
                  
                  			var array_items = [];
                  			var items = [];
                  			//console.log(item_image_list);
                  
                  			for (let i = 0; i < item_image_list.length; i++) {
                  
                  				console.log(item_image_list[i].width);
                  
                  				array_items.push({ src: item_image_list[i].src, w: item_image_list[i].width, h: item_image_list[i].height });
                  				//	items = { src: item_image_list[i].src };
                  
                  			}*/
            /*
                  			console.log(array_items);
                  
                  			var items = [
                  				{
                  					src: 'https://farm2.staticflickr.com/1043/5186867718_06b2e9e551_b.jpg',
                  					w: 496,
                  					h: 1024
                  				},
                  				{
                  					src: 'https://farm7.staticflickr.com/6175/6176698785_7dee72237e_b.jpg',
                  					w: 1024,
                  					h: 683
                  				}
                  			];
                  			console.log(items);*/
            e.preventDefault();
        });
    }
}

var item_extended_image = document.querySelectorAll(".fs-c-button--viewExtendedImage");

if (item_extended_image.length) {
    for (let i = 0; i < item_extended_image.length; i++) {
        item_extended_image[i].addEventListener("click", function (e) {
            var item_slide_list = document.querySelectorAll("#fs_productCarouselMainImage .slick-active");

            var current_index = item_slide_list[0].getAttribute("data-slick-index");

            /*
                  			for (let i = 0; i < item_image_list.length; i++) {
                  
                  				console.log(item_image_list[i].width);
                  
                  				items.push({ src: item_image_list[i].src, w: item_image_list[i].width, h: item_image_list[i].height });
                  
                  
                  			}
                  */
            openPhotoSwipe(current_index);
            //console.log('click');
            /*
                  			var item_image_list = document.querySelectorAll('.fs-c-productCarouselMainImage__image > a > img');
                  
                  			var array_items = [];
                  			var items = [];
                  			//console.log(item_image_list);
                  
                  			for (let i = 0; i < item_image_list.length; i++) {
                  
                  				console.log(item_image_list[i].width);
                  
                  				array_items.push({ src: item_image_list[i].src, w: item_image_list[i].width, h: item_image_list[i].height });
                  				//	items = { src: item_image_list[i].src };
                  
                  			}*/
            /*
                  			console.log(array_items);
                  
                  			var items = [
                  				{
                  					src: 'https://farm2.staticflickr.com/1043/5186867718_06b2e9e551_b.jpg',
                  					w: 496,
                  					h: 1024
                  				},
                  				{
                  					src: 'https://farm7.staticflickr.com/6175/6176698785_7dee72237e_b.jpg',
                  					w: 1024,
                  					h: 683
                  				}
                  			];
                  			console.log(items);*/
            e.preventDefault();
        });
    }
}

// sort item label event
var sort_items_label = document.querySelectorAll(".fs-c-sortItems__label");
var sort_items_duration = 0.4;

if (sort_items_label.length) {
    for (let i = 0; i < sort_items_label.length; i++) {
        sort_items_label[i].addEventListener("click", function (e) {
            //	console.log('click');

            var target_label = e.currentTarget;
            var target_menu = target_label.nextElementSibling;
            //	console.log(target_menu);

            if (target_menu.classList.contains("is-open")) {
                target_label.classList.remove("open");
                target_menu.classList.remove("is-open");

                gsap.fromTo(
                    target_menu, {
                        opacity: 1,
                        height: target_menu.scrollHeight,
                    }, {
                        opacity: 0,
                        height: 0,
                        duration: sort_items_duration,
                        onComplete: function () {
                            target_menu.style.removeProperty("opacity");
                            target_menu.style.removeProperty("height");
                        },
                    }
                );

                //	console.log('open');
            } else {
                //target_menu.classList.add('is-open');
                //	console.log('close');

                target_label.classList.add("open");
                target_menu.classList.add("is-open");

                gsap.fromTo(
                    target_menu, {
                        opacity: 0,
                        height: 0,
                    }, {
                        opacity: 1,
                        height: target_menu.scrollHeight,
                        duration: sort_items_duration,
                        onComplete: function () {
                            target_menu.style.removeProperty("opacity");
                            target_menu.style.removeProperty("height");
                        },
                    }
                );
            }
        });
    }
}
